<template>
  <form name="checkout" method="post" :action="checkoutRoute" v-on:submit="submitForm" class="w-100">
    <input type="hidden" name="mileage" :value="mileageId"/>
    <input type="hidden" name="mileage_value" :value="mileageValue"/>
    <input type="hidden" name="duration" :value="durationId"/>
    <input type="hidden" name="duration_value" :value="durationValue"/>
    <input type="hidden" name="vehicle_id" :value="vehicle.id"/>
    <input type="hidden" name="price" :value="price"/>
    <input type="hidden" name="_token" :value="csrf"/>
    <input type="hidden" name="comes_from_iframe" :value="comesFromIframe"/>
    <!-- Formular Daten Ende -->
    <f-button variant="primary" type="submit" block class="w-100">
      Jetzt abonnieren
    </f-button>
  </form>
</template>

<script>
export default {
  name: "CheckoutForm",

  props: {
    mileageId: {type: Number, required: true},
    durationId: {type: Number, required: true},
    mileageValue: {type: Number, required: true},
    durationValue: {type: Number, required: true},
    checkoutRoute: {type: String, required: true},
    vehicle: {type: Object, required: true},
    price: {type: Number, required: true},
    csrf: {type: String, required: true},
    comesFromIframe: {type: Boolean, required: false, default: true}
  },

  methods: {
    submitForm () {
      //Google Tag Manager
      dataLayer.push({
        'event': 'addToCart',
        'ecommerce': {
          'currencyCode': this.currency,
          'add': {                       // 'add' actionFieldObject measures.
            'products': [{               //  adding a product to a shopping cart.
              'name': this.vehicle.title,         // Name or ID is required.
              'id': this.vehicle.id,
              'price': this.price,
              'brand': this.vehicle.brand,
              'category': this.vehicle.category,
              'mileage': this.mileageValue,
              'duration': this.durationValue,
              'subsidiaryId': this.vehicle.subsidiaryId
            }]
          }
        }
      })
    }
  }
}
</script>

<style scoped>

</style>
